import helpers from "utils/helpers";
let yup = require("yup");

export const physiciansResource = {
  tableColConfig: [
    {
      id: "id",
      label: "ID",
    },
    {
      id: "physFirstName",
      label: "First Name",
    },
    {
      id: "physLastName",
      label: "Last Name",
    },
    {
      id: "physTitle",
      label: "Title",
    },
    {
      id: "npiNumber",
      label: "NPI Number",
    },
    {
      id: "ptanNumber",
      label: "PTAN#",
    },
  ],
  createPhysConfig: {
    inputsById: [
      "physFirstName",
      "physMiddleName",
      "physLastName",
      "physTitle",
      "npiNumber",
      "ptanNumber",
      "physPortalPrefCode",
    ],
    inputsByHash: {
      physFirstName: {
        label: "First Name",
        yup: helpers.getYupRequired("First Name"),
        autoFocus: true,
      },
      physMiddleName: {
        label: "Middle Name",
      },
      physLastName: {
        label: "Last Name",
        yup: helpers.getYupRequired("Last Name"),
      },
      physTitle: {
        label: "Title",
        type: "select",
        options: [
          { value: null, label: "None" },
          { value: "MD", label: "MD" },
          { value: "DO", label: "DO" },
          { value: "NP", label: "NP" },
          { value: "PA", label: "PA" },
          { value: "ND", label: "ND" },
          { value: "OD", label: "OD" },
          { value: "PhD", label: "PhD" },
          { value: "FNP", label: "FNP" },
          { value: "DNP", label: "DNP" },
          { value: "DC", label: "DC" },
          { value: "PA-C", label: "PA-C" },
          { value: "BC", label: "BC" },
          { value: "NMD", label: "NMD" },
          { value: "APRN", label: "APRN" },
          { value: "FNP-BC", label: "FNP-BC" },
          { value: "MPAS", label: "MPAS" },
          { value: "RPH", label: "RPH" },
          { value: "FNP-C", label: "FNP-C" },
          { value: "MD.,FACP", label: "MD.,FACP" },
          { value: "CRNP", label: "CRNP" },
          { value: "ARNP", label: "ARNP" },
          { value: "NP-C", label: "NP-C" },
          { value: "CNP", label: "CNP" },
        ],
        // Title label: 1px when not shrunk (no value), 4px when shrunk (has value/focus)
        inputWrapStyles: `
          label.MuiFormLabel-root {
            padding-top: 1px;
          }

          label.MuiFormLabel-root.MuiInputLabel-shrink {
            padding-top: 4px;
          }
        `,
        yup: yup
          .string()
          .required("Title is required")
          .nullable("Title is required"),
      },
      npiNumber: {
        label: "NPI#",
        yup: yup
          .string()
          .required("NPI# is required")
          .nullable("NPI# is required"),
      },
      ptanNumber: {
        label: "PTAN#",
      },
      physPortalPrefCode: {
        label: "Patient Portal Preferences",
        type: "autocomplete",
        resource: "lovs/PORTALPREF",
        accessor: (d) => ({
          value: d.portalPrefCode,
          label: d.portalPrefDesc,
        }),
      },
    },
    inputsGroupsByHash: {
      group1: {
        title: "Physician Information",
        ids: [
          ["physFirstName", "physMiddleName", "physLastName"],
          ["physTitle"],
          ["npiNumber"],
          ["ptanNumber"],
          ["physPortalPrefCode"],
        ],
      },
    },

    inputsGroupsById: ["group1"],
  },
};
